import {lazy, trigger, filter} from './lang.js';

export const or = (a,b) => {
    return (...args) => {
        return lazy(a, ...args) || lazy(b, ...args);
    };
};

export const and = (a,b) => {
    return (...args) => {
        return lazy(a, ...args) && lazy(b, ...args);
    };
};
